import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { FluidObject } from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image';

import Heading, { HeadingVariant } from 'src/components/Heading';
import Button, { ButtonAppearance } from 'src/components/Button';
import { mediaQuery } from 'src/themes/breakpoints';
import { colors } from 'src/themes/colors';

const Background = styled(BackgroundImage)<BannerProps>`
  padding: 30px 0 50px;

  ${({ main }) =>
    main &&
    css`
      height: auto;
      padding: 120px 0 40px;
    `}

  ${mediaQuery('md')} {
    padding: 100px 0 140px;

    ${({ main }) =>
      main &&
      css`
        height: 700px;
      `}
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 20px;

  &::before {
    background-color: #222222;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -2;
  }
`;

const ButtonWrapper = styled.div`
  margin: 40px 0 0;
  ${mediaQuery('md', 'max')} {
    width: 100%;
  }
`;

const TextWrapper = styled.p`
  color: ${colors.grey100};
  margin: 20px auto 10px;
  max-width: 900px;
  text-align: center;
`;

const SectionTitle = styled(Heading)`
  color: ${colors.grey100};
`;

const BannerHeading = styled(Heading)`
  color: ${colors.grey100};
  text-align: center;
`;

interface BannerProps {
  image: FluidObject;
  title: string;
  text?: any;
  main?: boolean;
  button?: {
    title: string;
    url: string;
  };
}

const Banner: FC<BannerProps> = ({ image, title, text, button, main }) => {
  return (
    <Background main={main} Tag="div" fluid={image}>
      <Content>
        {main ? (
          <BannerHeading variant={HeadingVariant.ALFA}>{title}</BannerHeading>
        ) : (
          <SectionTitle variant={HeadingVariant.BRAVO}>{title}</SectionTitle>
        )}
        {text && text.map((p, idx) => <TextWrapper key={idx}>{p}</TextWrapper>)}
        {button && (
          <ButtonWrapper>
            <Button url={button.url} appearance={ButtonAppearance.BRAVO}>
              {button.title}
            </Button>
          </ButtonWrapper>
        )}
      </Content>
    </Background>
  );
};

export default Banner;
